import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { JoiAccount } from 'globals/store/accounts.data';
import { BrandingImageType, createJoiBrandImageSet } from 'globals/store/publish.data';
import { Wrapper } from '../wrapper.component';
import { BrandImageComponent } from './brand-image.component';
import { CommonModule } from '@angular/common';
import { BrandingControlsWrapperComponent } from './brand-controls-wrapper.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'brand-image-editor',
    template: `
<branding-controls-wrapper
  [selected]="selectedId === 'empty'"
  [isAccountDefault]="type === 'headers' ? account.headerId === 'empty' : account.footerId === 'empty'"
  [hideDelete]="true"
  [onAccount]="onAccount" 
  (setAsAccountDefault)="setAsAccountDefault.emit('empty')"
  (select)="select.emit('empty')"
><div class="empty-template-title">No {{ type }}</div>
</branding-controls-wrapper>
<brand-image *ngFor="let template of account[type]; trackBy: trackById;"
  [account]="account"
  [template]="template"
  [selected]="template.id === selectedId"
  [isAccountDefault]="template.id === accountDefaultId"
  [editing]="editingId === template.id"
  [type]="type"
  [onAccount]="onAccount"
  [readOnly]="false"
  (update)="updateTemplates()"
  (edit)="editingId = $event ? template.id : null"
  (delete)="deleteTemplate(template.id)"
  (select)="select.emit(template.id)"
  (unselect)="select.emit(null)"
  (setAsAccountDefault)="setAsAccountDefault.emit(template.id)"
></brand-image>
<button *ngIf="onAccount" mat-button class="large" (click)="addTemplate()">{{ addText }}</button>
`,
    styles: [`
  brand-image { display: flex; margin-bottom: 20px; }
  branding-controls-wrapper { margin-bottom: 20px; display: block; }
`],
    standalone: true,
    imports: [BrandImageComponent, MatButtonModule, CommonModule, BrandingControlsWrapperComponent],
})
export class BrandImageEditorComponent extends Wrapper<BrandImageEditorComponent> implements OnInit {
  _file = "brand-image-editor"
  @Input() account: Partial<JoiAccount>
  @Input() type: BrandingImageType
  @Input() selectedId: string
  @Input() onAccount = false
  @Input() accountDefaultId: string

  @Output() select: EventEmitter<string> = new EventEmitter()
  @Output() setAsAccountDefault: EventEmitter<string> = new EventEmitter()

  editingId: string
  addText: string

  ngOnInit() {
    this.addText = `+ ADD NEW ${ this.type === 'headers' ? 'HEADER' : this.type === 'footers' ? 'FOOTER' : 'UNKNOWN TYPE OF IMAGE SET' }` 
  }

  addTemplate() {
    const newTemplate = createJoiBrandImageSet(this.type)
    this.account[this.type] = [...this.account[this.type], newTemplate]
    this.editingId = newTemplate.id
    this.updateTemplates()
  }

  updateTemplates() {
    this.accountService.updateAccount(this.account.id, { [this.type]: this.account[this.type] }, { file:this._file, function:'save', message:`There was an error updating the ${this.type} template`, error:new Error() })
  }

  deleteTemplate(id: string) {
    this.editingId = null
    this.account[this.type] = this.account[this.type].filter(t => t.id !== id)
    this.updateTemplates()
  }

}

